<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>发放排名 (当日数据每小时刷新一次)</span>
        </div>

        <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick">
          <el-tab-pane label="发放排名" name="first">
            <el-row :gutter="12">
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="money1" :title="'发放金币'" :typ="1" />
              </el-col>
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="spins1" :title="'发放体力'" :typ="2" />
              </el-col>
            </el-row>

            <el-row :gutter="12">
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="diamond1" :title="'发放钻石'" :typ="3" :send="false" />
              </el-col>
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="beastCoin1" :title="'发放野兽币'" :typ="4" :send="false" />
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="消耗排名" name="second">
            <el-row :gutter="12">
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="money2" :title="'消耗金币'" :typ="1" :send="false" />
              </el-col>
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="spins2" :title="'消耗体力'" :typ="2" :send="false" />
              </el-col>
            </el-row>

            <el-row :gutter="12">
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="diamond2" :title="'消耗钻石'" :typ="3" :send="false" />
              </el-col>
              <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
                <tableData ref="beastCoin2" :title="'消耗野兽币'" :typ="4" :send="false" />
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import tableData from '@/views/config/grand-rank-stat/components/table.vue'
import { getLastDates } from '@/utils'
export default {
  name: 'GrantRankStat',
  components: {
    tableData
  },
  data() {
    return {
      tabPosition: 'left',
      activeName: 'first',
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        channel: 1
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(0)
  },
  mounted() {
    this.getTables()
  },
  methods: {
    handleClick(tab, event) {
      this.queryParams.channel = parseInt(tab.index) + 1
      this.getTables()
    },
    handleQuery() {
      this.getTables()
    },
    getTables() {
      if (this.queryParams.channel === 1) {
        this.$refs.money1.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.spins1.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.diamond1.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.beastCoin1.refresh(this.queryParams.startDate, this.queryParams.channel)
      } else {
        this.$refs.money2.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.spins2.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.diamond2.refresh(this.queryParams.startDate, this.queryParams.channel)
        this.$refs.beastCoin2.refresh(this.queryParams.startDate, this.queryParams.channel)
      }
    }
  }
}
</script>

<style scoped>
</style>
